import { FormInputProps } from '@/@types/form.types';
import { cn } from '@/lib/utils';
import { Controller } from 'react-hook-form';
import InformationCircle from '@/components/icons/InformationCircle';

type Props<T extends {}> = {
	label?: string;
	placeholder?: string;
	optional?: boolean;
} & FormInputProps<T>;

const ETextAreaInput = <T extends {}>({
	label,
	placeholder = 'Enter remarks',
	optional = false,
	fieldName,
	control,
	className,
	containerClassName,
	disabled,
}: Props<T>) => {
	return (
		<div
			className={cn(
				'w-full flex flex-col gap-1.5 select-none',
				containerClassName,
			)}>
			{label && (
				<h4 className='text-sm font-medium'>
					{label}
					{optional && (
						<span className='text-popover-600'> (optional)</span>
					)}
				</h4>
			)}
			<Controller
				name={fieldName}
				control={control}
				render={({
					field: { value, onChange, onBlur },
					fieldState,
					formState,
				}) => (
					<>
						<textarea
							value={value}
							onChange={onChange}
							onBlur={onBlur}
							disabled={disabled || formState.disabled}
							placeholder={placeholder}
							className={cn(
								'h-20 p-3.5 border border-popover-100 rounded-semi-xl text-xs text-popover-800 bg-popover-10 focus:outline-hidden focus:border focus:border-primary-color-1000 placeholder:text-popover-600 disabled:bg-popover-50 transition-colors duration-150',
								fieldState.invalid ? 'border-error-1000' : '',
								className,
							)}
						/>
						{fieldState.invalid && (
							<div className='flex items-center gap-1.5'>
								<InformationCircle className='size-4 stroke-error-1000' />
								<span className='text-xs text-error-1000'>
									{fieldState.error?.message}
								</span>
							</div>
						)}
					</>
				)}
			/>
		</div>
	);
};

export default ETextAreaInput;
